import * as React from "react";
import { escapeRegExp } from "lodash-es";

export interface HighlighterProps {
  children: string;
  filter: string;
}

export const Highlighter = ({
  children,
  filter,
}: HighlighterProps): JSX.Element => {
  const filterLowerCase = filter.toLowerCase();

  const parts = children
    .split(new RegExp(`(${escapeRegExp(filter)})`, "gi"))
    .filter((n) => !!n)
    .map((n, idx) => {
      if (n.toLowerCase() === filterLowerCase) {
        return (
          <mark
            css={`
              .active && {
                color: inherit;
              }
            `}
            style={{
              padding: 0,
              fontWeight: "bold",
              backgroundColor: "transparent",
            }}
            key={idx}
          >
            {n}
          </mark>
        );
      }

      return n;
    });

  return <>{parts.map((n) => n)}</>;
};
